'use client';

import * as React from 'react';

import { Button } from '@/components/ui/button';

// Types
type T_Gender = 'men' | 'women';

type T_GenderButtonProps = {
  gender: T_Gender;
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
};

export function GenderButton({
  gender: _gender,
  isActive,
  onClick,
  children
}: T_GenderButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={`h-fit w-1/2 py-2.5 rounded-3xl text-base font-medium transition-colors hover:bg-bg-card ${
        isActive
          ? 'bg-card text-foreground font-bold'
          : 'text-muted-foreground hover:text-foreground'
      }`}
    >
      {children}
    </Button>
  );
}
